import seq, { SeqEvent, SeqLogLevel, SeqLoggerConfig, Logger as _Logger } from 'seq-logging/browser';
import Authentication from './Authentication';
import Guid, { _Guid } from './Guid';

const { log, warn, error } = console;

const levelMapping = {
    Verbose: log,
    Information: log,
    Warning: warn,
    Error: error,
    Fatal: error,
};

type FuncParameters = [string, unknown?, unknown?];

type AgencyInfo = {
    'Agency.Id': string;
    'Agency.DisplayName': string;
};

class Logger {
    private logger: _Logger;

    private sessionProperties: object | null = null;

    private sessionId: _Guid = '';

    constructor() {
        // Locally, just log on console. No need for SEQ-Logger
        if (window.location.hostname === 'localhost') {
            this.logger = {
                emit: (e: SeqEvent & { level: SeqLogLevel }) => {
                    // console.group('Logger');
                    // levelMapping[e.level](e)
                    // console.groupEnd();
                },
                close: async () => {},
                flush: async () => {
                    return false;
                },
            };
            return;
        }

        this.logger = new seq.Logger({
            serverUrl: SEQ_URL,
            apiKey: SEQ_TOKEN,
            maxBatchingTime: 10000, // 10 sec before batching and sending log
        } as SeqLoggerConfig);
    }

    // Generate ID and hold it until you end session se logs can have a relationship
    // Do not forget to end it, otherwise sessionId will be mixed!
    public startSession(arg: object) {
        this.sessionId = Guid.create();
        // Our custom properties
        this.sessionProperties = arg;
    }

    // Reset
    public endSession() {
        this.sessionId = '';
        this.sessionProperties = null;
    }

    private getBaseEvent(level: SeqLogLevel, message: string, RequestPayload: unknown = {}, ResponsePayload: unknown = {}) {
        const timestamp: Date = new Date();

        const agencyModel = Authentication.getAgencyModel();

        const agencyInfo = {
            'Agency.Id': agencyModel?.id ?? '',
            'Agency.DisplayName': agencyModel?.displayName ?? '',
            'User.FullName': agencyModel.userFullName,
        } as AgencyInfo;

        this.logger.emit({
            timestamp,
            level,
            messageTemplate: `-- FrontEnd: ${message}`,
            properties: {
                ...agencyInfo,
                ...this.sessionProperties,
                // Data we sent
                Request_Data: RequestPayload,
                // Data we get
                Response_Data: ResponsePayload,
                'Request.Id': this.sessionId ?? Guid.create(),
                Esig: 'Client', // Signal - Seq Logger filter on the dashboard
                Github_Actions_Count: localStorage.getItem('githubActionsCount') || '',
            },
        } as SeqEvent);
    }

    // All logs events

    public log_verbose(...args: FuncParameters) {
        this.getBaseEvent('Verbose', ...args);
    }

    public log_information(...args: FuncParameters) {
        this.getBaseEvent('Information', ...args);
    }

    public log_warning(...args: FuncParameters) {
        this.getBaseEvent('Warning', ...args);
    }

    public log_error(...args: FuncParameters) {
        this.getBaseEvent('Error', ...args);
    }

    public log_fatal(...args: FuncParameters) {
        this.getBaseEvent('Fatal', ...args);
    }
}

export default new Logger();
